
/* styles */
require("!!vue-style-loader!css-loader!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-08030c86&scoped=true!sass-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./OrdererInfo.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./OrdererInfo.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-08030c86!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./OrdererInfo.vue"),
  /* scopeId */
  "data-v-08030c86",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/page/subPages/MyPage/OrdererInfo.vue
// module id = 654
// module chunks = 0